export const buildUserName = (
  firstName?: Nullable<string>,
  lastName?: Nullable<string>,
) => [lastName, firstName].join(' ');

export const buildShortUserName = (firstName: string, lastName: string) => {
  const shortFirstName = firstName[0]?.toUpperCase();
  const shortLastName = lastName[0]?.toUpperCase();

  return [shortFirstName, shortLastName].join('');
};

export const buildUserInitialsByEmail = (email: string) => {
  const [firstName, lastName] = email.split('');

  return [firstName.toUpperCase(), lastName.toUpperCase()].join('');
};
